import Choices from "choices.js";

export default class BlockSectorsFromLocalities {
    constructor() {
        this.blocks = document.querySelectorAll(".block-sectors-from-localities");

        if (this.blocks && this.blocks.length > 0) {
            this.initSearch();
            this.mapActions();
        }
    }

    initSearch() {
        this.blocks.forEach((block) => {
            const select = block.querySelector(".search-sector-from-locality");
            const button = block.querySelector(".search-sector-btn");
            const buttonTitles = button.querySelectorAll(".sector-name");
            const map = block.querySelector(".map-sectors");
            const mapSectors = block.querySelectorAll(".map-sectors .sector");

            if (select) {
                const urlBase = select.dataset.postTypePath;

                const choices = new Choices(select, {
                    removeItemButton: true,
                    placeholder: true,
                    placeholderValue: select.dataset.placeholderValueText ?? "Chercher votre commune...",
                    searchPlaceholderValue: select.dataset.searchPlaceholderText ?? "Rechercher...",
                    itemSelectText: select.dataset.itemSelectText ?? "Entrée pour sélectionner",
                    loadingText: select.dataset.loadingText ?? "Chargement...",
                    noResultsText: select.dataset.noResultsText ?? "Aucun résultat trouvé",
                });

                // Fonction utilitaire pour afficher/masquer le bouton
                const toggleButton = () => {
                    const value = choices.getValue(true);

                    const hasValue =
                        (Array.isArray(value) && value.length > 0) ||
                        (typeof value === "string" && value.trim() !== "");

                    if (hasValue) {
                        button?.classList.add("is-visible");
                        map.dataset.currentSector = value;
                        button.querySelector("a").href = urlBase + value + "/";
                        buttonTitles.forEach((title) => {
                            title.ariaHidden = value !== title.dataset.sector;
                            if (title.dataset.sector === value) {
                                title.classList.add("is-visible");
                            } else {
                                title.classList.remove("is-visible");
                            }
                        });

                        mapSectors.forEach(sector => {
                            if (sector.id === value) {
                                sector.classList.add("is-active");
                                sector.classList.remove("is-inactive");
                            } else {
                                sector.classList.remove("is-active");
                                sector.classList.add("is-inactive");
                            }
                        });
                    } else {
                        button?.classList.remove("is-visible");
                        map.dataset.currentSector = "";

                        mapSectors.forEach(sector => {
                            sector.classList.remove("is-active");
                            sector.classList.remove("is-inactive");
                        });
                    }
                };

                // Au chargement : vérifier si une valeur existe déjà
                toggleButton();

                // Quand un item est ajouté
                select.addEventListener("change", () => toggleButton());
            }

        });
    }

    mapActions() {
        this.blocks.forEach((block) => {
            const map = block.querySelector(".map-sectors");
            if (map) {
                const mapSectors = map.querySelectorAll(".sector");
                if (mapSectors && mapSectors.length > 0) {
                    mapSectors.forEach((mapSector) => {
                        const sectorID = mapSector.id;

                        mapSector.addEventListener("click", () => {
                            const target = block.querySelector(`.sectors-btns a#${sectorID}`);
                            target.click();
                        });

                        mapSector.addEventListener("mouseenter", (e) => {
                            mapSectors.forEach(sector => {
                                if (sector.id === sectorID) {
                                    sector.classList.add("is-active");
                                    sector.classList.remove("is-inactive");

                                } else {
                                    sector.classList.remove("is-active");
                                    sector.classList.add("is-inactive");
                                }
                            });
                        });

                        mapSector.addEventListener("mouseleave", (e) => {
                            mapSectors.forEach(item => {
                                if (map.dataset.currentSector) {
                                    if (item.id === map.dataset.currentSector) {
                                        item.classList.add("is-active");
                                        item.classList.remove("is-inactive");
                                    } else {
                                        item.classList.remove("is-active");
                                        item.classList.add("is-inactive");
                                    }
                                } else {
                                    item.classList.remove("is-active");
                                    item.classList.remove("is-inactive");
                                }
                            });
                        });
                    });
                }
            }
        });
    }
}